

import { Observable } from 'rxjs';
import { Parameter } from '../../../../@core/interfaces/common/parameter';


export interface CrmParameter extends Parameter {
  SearchTerm: number;
  OrderBy: string;
}

export interface CrmProductMaster{
  crmProductId:number;
  crmProductName: string;
  crmProductPrice: number;
  gst:any;
  crmProductActiveFlag: string;
  tenantId: string;
}

export interface advertisementCategoryMaster{
  id:number;
  name: string;
  tenantId: string;
}

export interface EnquiryStatusMaster{
  enqStatusId:number;
  enqStatusShortDesc: string;
  enqStatusLongDesc:string;
  enqStatusActiveFlag:string;
  tenantId: string;
}

export interface SalesQuoteMaster{
  id:number;
  name:number;
  longDesc: string;
  statusType:string;
  tenantId: string;
}


export interface SalesQuoteMst {
  enquiryNo: number;
  date: string;
  referenceNumber: string;
  type: string;
  quoteTerms:any;
  sentDate: any;
  createdBy: number;
  approvedBy: number;
  quoteFor: string;
  validTill: any;
  status: number;
  remarks: string;
  revisonNumber: number;
  salesQuoteFooterNotes:string;
  amount: number;
  orderNumber: string;
  updatedBy: number;
  createdDate:any,
  updatedDate:any,
  createdIP:string,
  updatedIP:string;
  SalesQuoteDet:any;
}

export interface SalesQuoteDetail {
  productId: number;
  rowNo: string;
  qty: number;
  unitPrice: number;
  amount: number;
  discountType: string;
  discountPercentage: number;
  discountAmount: number;
  discoutCalValue: number;
  taxableAmount: number;
  gstTotalPer:any;
  gstFlag: any;
  cgst: number;
  sgst: number;
  igst: number;
  cgstValue: number;
  sgstValue: number;
  igstValue: number;
  totalGstValue: number;
  taxAmount: number;
  lineTotal: number;
}



export abstract class CrmModuleData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract getById(url: string,data?: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
